import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LayoutsModule } from './components/layouts/layouts.module';
import { ScreensModule } from './components/screens/screens.module';
import { WidgetsModule } from './components/widgets/widgets.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, WidgetsModule, ScreensModule, LayoutsModule],
})
export class AppComponent {
  title = 'QFA';
}
